import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../../common/AutoBindComponent";

import * as vrLayoutActions from "../../../actions/voortgangsrapportLayoutActions";
import * as voortgangsrapportActions from "../../../actions/voortgangsrapportActions";
import * as beadActions from "../../../actions/beadActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import * as exceptionActions from "../../../actions/exceptionActions";
import * as types from "../../../constants/ComponentConstants";
import VRProjectForm from "./VRProjectForm";
import VRProjectPageHelper from "./VRProjectPageHelper";
import unsavedDataDialogHandler from "../../common/UnsavedDataDialogHandler";

import EasterEggHandler from "../../common/EasterEggHandler";
import * as pageConstants from "../../../constants/EasterEggConstants";


class VRProjectPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			vrProject: {},
			errors: {},
			hasUnsavedChanges: false
		};

		this.pageHelper = new VRProjectPageHelper(this);
		this.easterEggHandler = new EasterEggHandler(this, pageConstants.VOORTGANGSRAPPORT_PROJECT);
	}

	componentDidMount() {
		this.pageHelper.init();
		this.easterEggHandler.bind();
	}
	componentWillUnmount() {
		this.easterEggHandler.unbind();
	}

	componentWillMount() {
		
	}

	handleOnChange(event, data) {
		this.pageHelper.onChange(event, data);
	}

	handleOnSave() {
		this.pageHelper.onSave();
	}

	isReadyToRender() {
		return !!this.state.vrProject
			&& this.state.vrProject.id
			&& this.props.refGemeenten;
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}

		const vrProject = this.state.vrProject;

		return (
			<VRProjectForm
				disabled={this.props.disableInput}
				vrProject={vrProject}
				errors={this.state.errors}
				color={types.COLOR_PINK}
				onChange={this.handleOnChange}
				onSave={this.handleOnSave}
				validationMessageType={this.props.validationMessageType}
			/>
		);
	}
}

// ----------------------------------------------------------------------------
VRProjectPage.propTypes = {
	loadLayout: PropTypes.func,
	refGemeenten: PropTypes.object.isRequired,
	dossierId: PropTypes.string,
	vrProjectId: PropTypes.string,
	isNew: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;
	const vrProjectId = ownProps.params.vrProjectId;
	const isNew = ownProps.route.params.isNew;
	const refGemeenten = state.referentie.gemeenten || {};
	const disableInput = state.layout.disableInputComponents;

	return {
		dossierId,
		vrProjectId,
		isNew,
		refGemeenten,
		disableInput,
		validationMessageType: state.voortgangsrapportLoaded.hasValidationErrors ? types.ValidationMessageTypes.ERROR : types.ValidationMessageTypes.WARNING
	};
}
function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(vrLayoutActions.loadVRProjectPageLayout, dispatch),
		setDisabledInputComponents: bindActionCreators(vrLayoutActions.setDisabledInputComponents, dispatch),
		ajaxStarted: bindActionCreators(ajaxActions.started, dispatch),
		ajaxEnded: bindActionCreators(ajaxActions.ended, dispatch),
		ajaxFailed: bindActionCreators(ajaxActions.failed, dispatch),
		throwException: bindActionCreators(exceptionActions.throwException, dispatch),
		beadsLoaded: bindActionCreators(beadActions.voortgangsrapportBeadsLoaded, dispatch),
		voortgangsrapportLoaded: bindActionCreators(voortgangsrapportActions.notifyLoadedVoortgangsrapport, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(VRProjectPage));